"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
}
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
__exportStar(require("class-validator"), exports);
__exportStar(require("class-transformer"), exports);
__exportStar(require("./dtos/Analytics"), exports);
__exportStar(require("./dtos/Alliance"), exports);
__exportStar(require("./dtos/Avatar"), exports);
__exportStar(require("./dtos/Battle"), exports);
__exportStar(require("./dtos/BattleEvent"), exports);
__exportStar(require("./dtos/Quest"), exports);
__exportStar(require("./dtos/PlaceAttack"), exports);
__exportStar(require("./dtos/PlaceUpgrade"), exports);
__exportStar(require("./dtos/Camp"), exports);
__exportStar(require("./dtos/Character"), exports);
__exportStar(require("./dtos/Goal"), exports);
__exportStar(require("./dtos/Item"), exports);
__exportStar(require("./dtos/ItemTemplate"), exports);
__exportStar(require("./dtos/Loot"), exports);
__exportStar(require("./dtos/Map"), exports);
__exportStar(require("./dtos/Notifications"), exports);
__exportStar(require("./dtos/Place"), exports);
__exportStar(require("./dtos/Rank"), exports);
__exportStar(require("./dtos/User"), exports);
__exportStar(require("./dtos/Device"), exports);
__exportStar(require("./dtos/Channel"), exports);
__exportStar(require("./dtos/Pagination"), exports);
__exportStar(require("./dtos/Skill"), exports);
__exportStar(require("./dtos/Resources"), exports);
__exportStar(require("./dtos/GeoIp"), exports);
__exportStar(require("./dtos/Ack"), exports);
__exportStar(require("./dtos/GameConfig"), exports);
__exportStar(require("./dtos/Osm"), exports);
__exportStar(require("./dtos/Friendship"), exports);
__exportStar(require("./errors"), exports);
//# sourceMappingURL=index.js.map